import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'combo-estado-civil',
  templateUrl: './combo-estado-civil.component.html',
  styleUrls: ['./combo-estado-civil.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboEstadoCivilComponent implements OnInit {

  @ViewChild('comboEstadoCivil', {static: false}) comboEstadoCivil;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Dados estáticos do estado civil
    this.dados = [
      { id: 1, tipo: 'Solteiro' },
      { id: 2, tipo: 'Casado' },
      { id: 3, tipo: 'União Estável' },
      { id: 4, tipo: 'Divorciado' },
      { id: 5, tipo: 'Viúvo' }
    ];

    this.preencherCombo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      this.selecionado = _.find(this.dados, { tipo: this.selecionado});
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
